export default "__VITE_ASSET__D3I8171J__"